var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagDivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 51,
    viewBox: "0 0 2 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag colors divider"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624177",
    y: 35.0625,
    width: 1.15909,
    height: 15.9375,
    fill: "#006F30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624178",
    y: 17.5312,
    width: 1.15909,
    height: 15.9375,
    fill: "#C8001B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624179",
    width: 1.15909,
    height: 15.9375,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDivider);
export default __webpack_public_path__ + "static/media/flag_divider.3d9101cacb34214d7600802bc64fb44f.svg";
export { ForwardRef as ReactComponent };